import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vormats.webp';
import screenshot_target from '../../../images/letterfunnel/janjaapvandenhoek.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jan-Jaap van den Hoek"
      firstname="Jan-Jaap"
      companyname="Vormats"
      competition="Storykit en Moovly"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/janjaapvandenhoek.js